<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <popup-add-product ref="popupAddProduct" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <p>Booking products - used for the the booking forms</p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            type="relief"
            color="primary"
            @click="createNewProduct"
            v-if="hasPermission('vp.crm.bookingproducts.edit')"
          >
            Add product
          </vs-button>
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <vs-table
        v-if="bookingProducts"
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        maxItems="10"
        :data="bookingProducts"
        noDataText="No data"
        @selected="onClicked(selected.id)"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th sort-key="id">Identifier</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="price">Price</vs-th>
          <vs-th sort-key="updatedAction">Last updated</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.id }}
                </p>
              </vs-td>
              <vs-td class="flex flex-row">
                <div class="flex items-center">
                  <img v-if="tr.imageUrl" :src="tr.imageUrl" width="98" height="98" class="mr-3 rounded" />
                  <div>
                    <p class="product-name font-medium truncate">
                      {{ tr.name }}
                    </p>
                    <p class="product-name truncate text-muted">
                      {{ tr.description }}
                    </p>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  <span>
                    {{ tr.price }}
                  </span>
                  <span v-if="tr.beforePrice != 0">
                    <span class="text-muted">({{ tr.beforePrice }})</span>
                  </span>
                </p>
              </vs-td>

              <vs-td>
                <p class="product-category">{{ moment(tr.updatedAction.timestamp).format("DD-MM-YYYY") }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import PopupAddProduct from "./Components/PopupAddProduct.vue";

export default {
  components: { PopupAddProduct },
  data() {
    return {
      moment,
      selected: [],
    };
  },
  methods: {
    createNewProduct() {
      this.$refs.popupAddProduct.show();
    },
    onClicked(id) {
      this.$router
        .push({
          name: "booking-product",
          params: { id: id },
        })
        .catch(e => {
          console.log("Booking product navigation error", e);
        });
    },
  },
  computed: {
    ...mapGetters({
      bookingProducts: "bookingProducts/bookingProducts",
      isLoading: "bookingProducts/isLoading",
    }),
  },

  async mounted() {
    await this.$store.dispatch("bookingProducts/getAll");
  },
};
</script>
